import { ListRow } from '@/modules/shared/components/list-row/ListRow'
import { getTaskTypeDescription } from '../../utils/task.utils'
import { TaskStatusLabel } from './TaskStatusLabel'

import type { Task } from '../../types/task.types'

// Which icon stands for which kind of task; partners bring their own mark.
function TaskIcon({ task }: { task: Task }) {
  switch (task.type) {
    case 'Message': {
      return <ListRow.Icon icon={['fal', 'message-check']} />
    }
    case 'Document': {
      return <ListRow.Icon icon={['fal', 'signature']} />
    }
    case 'Remecare': {
      return <img src='/img/svg/remecare-icon.svg' alt='Remecare' />
    }
    case 'Hylyght': {
      return <img src='/img/svg/hylyght-icon.svg' alt='Hylyght' />
    }
    case 'Content': {
      return <ListRow.Icon icon={['fal', 'newspaper']} />
    }
    case 'Questionnaire': {
      if (task.questionnaireResponse?.status === 'in-progress' && task.status !== 'expired') {
        return <ListRow.Icon icon={['far', 'circle-three-quarters-stroke']} />
      }

      return <ListRow.Icon icon={['fal', 'clipboard-check']} />
    }
    case 'FileUploadRequest': {
      return <ListRow.Icon icon={['fal', 'arrow-up-from-line']} />
    }
    default: {
      return null
    }
  }
}

// A row shows a task; what tapping it does belongs to whatever wraps it (a button or a link).
type TaskItemProps = {
  task: Task
  /** The home preview shows the title and status only, the status under the title. */
  preview?: boolean
}

export const TaskItem = ({ task, preview = false }: TaskItemProps) => (
  <ListRow>
    <ListRow.Badge>
      <TaskIcon task={task} />
    </ListRow.Badge>
    <ListRow.Title>{task.display}</ListRow.Title>
    {preview ? (
      <ListRow.Description>
        <TaskStatusLabel task={task} />
      </ListRow.Description>
    ) : (
      <>
        <ListRow.Description>{getTaskTypeDescription(task)}</ListRow.Description>
        <ListRow.Meta>
          <TaskStatusLabel task={task} />
        </ListRow.Meta>
      </>
    )}
  </ListRow>
)
